import React, { useEffect, useState } from 'react';
import { Box, TextField, MenuItem, Button, Typography, useTheme } from '@mui/material';

const Profile = ({ authHeaders, backEnd }) => {
  const theme = useTheme();
  const [formData, setFormData] = useState({
    firstname: '',
    lastname: '',
    position: '',
    email: '',
    password: '',
  });

  useEffect(() => {

    const fetchUserDetails = async () => {
      try {
        const response = await fetch( backEnd + 'get_user_details', {
          method: 'GET',
          headers: {
            Authorization: authHeaders,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch user details');
        }

        const data = await response.json();
        setFormData({
          firstname: data.firstname || '',
          lastname: data.lastname || '',
          position: data.position || '',
          email: data.email || '',
          password: '', // Keep password empty as required
        });
      } catch (error) {
        console.error('Error fetching user details:', error);
      }
    };

    fetchUserDetails();
  }, [authHeaders, backEnd]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async () => {
    try {
      const response = await fetch(backEnd + 'save_user_details', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: authHeaders,
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error('Failed to save user details');
      }

      alert('Данните са запазени успешно!');
    } catch (error) {
      // console.error('Error saving user details:', error);
      alert('Грешка при запазване на данните!');
    }
  };

  return (
    <Box sx={{ maxWidth: 600, margin: '0 auto', textAlign: 'left' }}>
      <Typography variant="h5" gutterBottom sx={{ color: theme.palette.text.primary, fontWeight: 'bold', textAlign: 'center'}}>
        Промяна на профил
      </Typography>
      <TextField
        label="Име"
        name="firstname"
        value={formData.firstname}
        onChange={handleChange}
        fullWidth
        margin="normal"
      />
      <TextField
        label="Фамилия"
        name="lastname"
        value={formData.lastname}
        onChange={handleChange}
        fullWidth
        margin="normal"
      />
      <TextField
        select
        label="Позиция"
        name="position"
        value={formData.position}
        onChange={handleChange}
        fullWidth
        margin="normal"
        disabled
      >
        <MenuItem value="Agent">Брокер</MenuItem>
        <MenuItem value="Person">Частно лице</MenuItem>
      </TextField>
      <TextField
        label="Мейл"
        name="email"
        value={formData.email}
        onChange={handleChange}
        fullWidth
        margin="normal"
  x
      />
      <TextField
        label="Парола"
        name="password"
        value={formData.password}
        onChange={handleChange}
        fullWidth
        margin="normal"
        type="password"
      />
      <Button
        variant="contained"
        color="primary"
        onClick={handleSubmit}
        sx={{ marginTop: 2 }}
      >
        Запази
      </Button>
    </Box>
  );
};

export default Profile;
